(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Small-boxs-Carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  if (typeof Swiper !== 'undefined') {
    // Duplicate slides so loop feels endless
    const swiperWrapper = document.querySelector('.icon-text-swiper .swiper-wrapper');
    if (swiperWrapper && swiperWrapper.children.length > 0) {
      swiperWrapper.innerHTML += swiperWrapper.innerHTML;
    }

    new Swiper('.icon-text-swiper', {
      slidesPerView: 8,
      spaceBetween: 10,
      loop: false, // we fake loop by duplicating slides
      speed: 4000, // higher = slower
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      freeMode: {
        enabled: true,
        sticky: false
      },
      freeModeMomentum: false,
      breakpoints: {
        768: { slidesPerView: 8 },
        480: { slidesPerView: 3 },
        0: { slidesPerView: 2.5 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["small-boxs-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  if (typeof Swiper !== 'undefined') {
    // Duplicate slides so loop feels endless
    const swiperWrapper = document.querySelector('.icon-text-swiper .swiper-wrapper');
    if (swiperWrapper && swiperWrapper.children.length > 0) {
      swiperWrapper.innerHTML += swiperWrapper.innerHTML;
    }

    new Swiper('.icon-text-swiper', {
      slidesPerView: 8,
      spaceBetween: 10,
      loop: false, // we fake loop by duplicating slides
      speed: 4000, // higher = slower
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      freeMode: {
        enabled: true,
        sticky: false
      },
      freeModeMomentum: false,
      breakpoints: {
        768: { slidesPerView: 8 },
        480: { slidesPerView: 3 },
        0: { slidesPerView: 2.5 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
